// Ported from EnterpriseTemplates react-project-template (Release 1.3.1), PMS slice 4b.
// Catalog screen ORG_BUSINESS_UNIT (database-template seed/026).
import React from 'react';
import { OrganisationMasterScreen } from '../OrganisationMasterScreen';
import { businessUnitDefinition } from '../organisationDefinitions';

const BusinessUnitMasterScreen: React.FC<{ moduleIcon?: string; tabId?: string; moduleName?: string; allowedActions?: string[] }> = (props) => (
  <OrganisationMasterScreen definition={businessUnitDefinition} {...props} />
);

export default BusinessUnitMasterScreen;
